import React, { useState, useEffect } from 'react';
import {
  ProgressTracker,
  ProgressTrackerItem,
  Alert
} from '@emorg-prd/react-standard';
import LocationDetails from '../../shared/formTabs/locationDetails';
import LocationBusinessLine from '../../shared/formTabs/locationBusinessLine';
import CreateLocation from '../../shared/formTabs/createLocation';
import LocationSite from '../../shared/formTabs/locationSite';
import LocationBuilding from '../../shared/formTabs/locationBuilding';
import ReviewFinish from '../../shared/formTabs/reviewFinish';
import FormCompletionChecks from '../../shared/formTabs/FormCompletionChecks';
import LoaderIcon from '../../loaderIcon';
import './NewLocationBasePage.css';
import { Destination } from '../../../api/Destination.js';

const NewLocationBasePage = (props) => {
  let { isAuthorized } = props;
  const [pageLoaded, setPageLoaded] = useState(true);
  const [errorCode, setErrorCode] = useState('');
  const [activeTab, setActiveTab] = useState(1);
  const [isTabCompleteArray, setIsTabCompleteArray] = useState(Array(6).fill(false));
  const [prevTab, setPrevTab] = useState([1]);
  const [locationState, setLocationState] = useState({
    locationName: '',
    locationStreetAddress1: '',
    locationStreetAddress2: '',
    country: { id: null, name: '' },
    countrySubdivision: { id: null, name: '' },
    locationCity: '',
    locationPostalCode: '',
    locationCounty: '',
    latitude: '',
    longitude: '',
    timezone: { timezoneId: null, timezoneName: '' },
    locationDesc: '',
    realEstateInterestList: [
      {
        isNew: true,
        realEstateInterestName: '',
        realEstateInterestTypeId: '',
        primary: true,
        realEstateInterestSourceSystemRelate: [],
        realEstateInterestDesc: '',
        realEstateInterestLatitude: '',
        realEstateInterestLongitude: '',
        realEstateInterestFrontageSize: '',
        realEstateInterestDepthSize: '',
        realEstateInterestArea: '',
        realEstateInterestSizeUOM: '',
        realEstateInterestBusinessLineAlias: '',
      },
    ],
    realEstateInterestDropdown: [[]],
    primaryUseType: { id: null, name: '', parentId: null, isActive: true },
    isJointVenture: false,
    affiliateOwnershipPercentage: '100',
    jVOwnershipPercentage: '0',
    destinationSystem: {
      Connexion: Destination.Connexion,
    },
    locationOperationStatus: { id: null, name: '', isActive: true },
    storeBrand: { id: null, name: '' },
    fuelBrand: { id: null, name: '' },
    stewardshipCostObjectList: [],
    sourceSystemLinkList: [],
    businessLineAllocationList: [
      {
        businessLineCode: 0,
        businessLineName: '',
        businessLineReportUnitCompanyCode: 0,
        businessLineReportUnitName: '',
        allocationPercent: 0,
        businessLineFilteredList: [],
        locationId: '',
      },
    ],
    epsBusinessLineAllocationList: [
      {
        eps_business_vc_id: 0,
        businessValueChain: '',
        eps_business_line_id: 0,
        businessLine: '',
        epsAllocationPercent: 0,
      },
    ],
    siteName: '',
    siteCode: '',
    siteOperationStatus: '',
    siteOperationStatusId: 0,
    sitePrimaryUseType: '',
    sitePrimaryUseTypeId: 0,
    itSiteCodeList: [],
    siteSourceLinkList: [],
    buildingList: [
      {
        buildingName: '',
        buildingDesc: '',
        sourceSystemReferenceId: '',
        sourceSystemIdTypeId: 0,
        isNuvoloBuildingValid: false,
        previousNuvoloBuildingId: '',
        validationSymbol: '',
        loadingValidation: false,
        validationErrorMessage: '',
      }
    ],
    toggleNewExisting: undefined,
    isCheckedConnexion: false,
  });
  const [isLoading, setIsLoading] = useState(false);
  const [isFormComplete, setIsFormComplete] = useState(false);
  const [sourceSystemList, setSourceSystemList] = useState();
  const [sourceSystemTypeList, setSourceSystemTypeList] = useState();

  useEffect(() => {
    let tempArray = [...isTabCompleteArray];
    tempArray[6] = true;
    setIsTabCompleteArray(tempArray);
  }, []);

  const onChange = (field, value) => {
    setLocationState((prev) => ({ ...prev, [field]: value }));
  };

  const onSetProgressTabComplete = () => {
    let tempArray = [...isTabCompleteArray];
    if (prevTab === 1) {
      tempArray[1] = FormCompletionChecks.checkFormCompleteForCreateLocation(locationState);
    } else if (prevTab === 2) {
      tempArray[2] = FormCompletionChecks.checkFormCompleteForLocationDetails(locationState);
    } else if (prevTab === 3) {
      tempArray[3] = FormCompletionChecks.checkFormCompleteForBusinessLine(locationState);
    } else if (prevTab === 4) {
      tempArray[4] = FormCompletionChecks.checkFormCompleteForSite(locationState);
    } else if (prevTab === 5) {
      tempArray[5] = FormCompletionChecks.checkFormCompleteForBuilding(locationState);
    }

    if (activeTab === 6) {
      tempArray[2] = FormCompletionChecks.checkFormCompleteForLocationDetails(locationState);
      tempArray[4] = FormCompletionChecks.checkFormCompleteForSite(locationState);
    }
    setIsTabCompleteArray(tempArray);
    setIsFormComplete(tempArray[1] && tempArray[2] && tempArray[3] && tempArray[4] && tempArray[5]);
  };

  const onNavigateForward = () => {
    setPrevTab(activeTab);
    if (activeTab === 6) {
      return;
    }
    navigateToTab(activeTab + 1);
  };

  const onNavigateBackward = () => {
    setPrevTab(activeTab);
    if (activeTab === 1) {
      return;
    }
    setActiveTab(activeTab - 1);
  };

  const navigateToTab = (tabNum) => {
    setPrevTab(activeTab);
    setActiveTab(tabNum);
  };

  const renderProgressTab = (tabNum, text) => {
    if (tabNum === activeTab) {
      return (
        <ProgressTrackerItem label={text} active>
          {tabNum}
        </ProgressTrackerItem>
      );
    } else if (isTabCompleteArray[parseInt(tabNum)]) {
      return (
        <ProgressTrackerItem
          label={text}
          onClick={() => navigateToTab(tabNum)}
          style={{ cursor: 'pointer' }}
          complete //react unity style for completed progress tracker item
        >
          {tabNum}
        </ProgressTrackerItem>
      );
    } else {
      return (
        <ProgressTrackerItem
          label={text}
          onClick={() => navigateToTab(tabNum)}
          className='incomplete'
          style={{ cursor: 'pointer' }}
        >
          {tabNum}
        </ProgressTrackerItem>
      );
    }
  };

  const handlePageError = (message) => {
    switch (true) {
      case (message.includes('Network')):
        setErrorCode('Network');
        break;
      case (message.includes('400')):
        setErrorCode('Bad Request');
        break;
      case (message.includes('403')):
        setErrorCode('Forbidden');
        break;
      case (message.includes('404')):
        setErrorCode('Not Found');
        break;
      case (message.includes('500') || message.includes('Internal Server')):
        setErrorCode('Internal Server');
        break;
      case (message.includes('map')):
        setErrorCode('Mapping');
        break;
      default:
        break;
    }
    setPageLoaded(false);
  }

  const renderTabForm = () => {
    switch (activeTab) {
      case 1: {
        return (
          <CreateLocation
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 2: {
        return (
          <LocationDetails
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
            sourceSystemTypeList={sourceSystemTypeList}
            sourceSystemList={sourceSystemList}
            setSourceSystemTypeList={setSourceSystemTypeList}
            setSourceSystemList={setSourceSystemList}
          />
        );
      }
      case 3: {
        return (
          <LocationBusinessLine
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 4: {
        return (
          <LocationSite
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 5: {
        return (
          <LocationBuilding
            {...locationState}
            onChange={onChange}
            handlePageError={handlePageError}
            onNavigateForward={onNavigateForward}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
          />
        );
      }
      case 6: {
        return (
          <ReviewFinish
            locationState={locationState}
            onChange={onChange}
            isAuthorized={isAuthorized}
            handlePageError={handlePageError}
            onNavigateBackward={onNavigateBackward}
            onSetProgressTabComplete={onSetProgressTabComplete}
            showLoadingSpinner={showLoadingSpinner}
            isFormComplete={isFormComplete}
            setIsFormComplete={setIsFormComplete}
            sourceSystemTypeList={sourceSystemTypeList}
            sourceSystemList={sourceSystemList}
            setSourceSystemTypeList={setSourceSystemTypeList}
            setSourceSystemList={setSourceSystemList}
          />
        );
      }
      default: {
        alert(activeTab);
      }
    }
  };
  const showLoadingSpinner = (value) => {
    setIsLoading(value);
  };

  return (
    <div>
      {pageLoaded && <div>
        {isLoading && <LoaderIcon />}
        {!isLoading && !isAuthorized &&
          <Alert variant='error' className='base-page-auth-alert'>
            User is Not Authorized to Create Locations
          </Alert>
        }
        <h3 style={{ paddingLeft: '40px' }}>
          Create Location {locationState.locationName && '- ' + locationState.locationName}
        </h3>
        <ProgressTracker style={{ paddingLeft: '40px', paddingRight: '40px' }}>
          {renderProgressTab(1, 'Create Location')}
          {renderProgressTab(2, 'Location Details')}
          {renderProgressTab(3, 'Business Line')}
          {renderProgressTab(4, 'Site')}
          {renderProgressTab(5, 'Buildings')}
          {renderProgressTab(6, 'Review and Finish')}
        </ProgressTracker>
        {renderTabForm()}
      </div>}

      {!pageLoaded && <div>
        <h1 style={{ textAlign: 'center', fontSize: '2rem' }}>
          {errorCode} Error Occurred
        </h1>
      </div>}
    </div>
  );
};
export default NewLocationBasePage;
